
import { Observable } from "rxjs";
import { ExtentDTO } from "~app/common/models/common/ExtentDTO";
import { ICommand } from "~app/common/services/cqs/model-action.service";
import { IExtent } from "~app/features/planera/model/IExtent";

export interface IExtentSelectorConfig {
    initialExtent: IExtent;
    id: number;
    mode: ExtentSelectorMode;
    viewMode: ExtentSelectorViewMode;
}

export interface IExtentSelectorSymbol {
    center: [number, number];
    type: ExtentSelectorSymbolType;
}

export interface IExtentSelectorLayerFilter {
    layerName: string;
    layerInfoName: string;
    guidProperty: string;
    ids: string[];
}

export enum ExtentSelectorSymbolType {
    Arbetsorder = "Arbetsorder",
    Atgard = "Atgard",
    Oversiktskarta1 = "Oversiktskarta1",
    Oversiktskarta2 = "Oversiktskarta2",
    Detaljkarta = "Detaljkarta"
}

export enum KartutsnittTyp {
    Oversiktskarta1 = "Översiktskarta 1",
    Oversiktskarta2 = "Översiktskarta 2",
    Detaljkarta = "Detaljkarta"
}

export enum ExtentSelectorMode {
    Arbetsorder = "Arbetsorder" // Add Virkesköp when time comes
}

export enum ExtentSelectorViewMode {
    Titta,
    Redigera
}

export interface IForeslagetKartutsnitt {
    oversiktskarta1: IKartutsnitt;
    oversiktskarta2: IKartutsnitt;
    detaljkartor: IKartutsnitt[];
}

export interface IKartutsnitt   {
    id: number;
    skala: number;
    extent: ExtentDTO;
    typ: string;
    guid: string;
}

export interface IExtentSelectorService {
    get(id: number): Observable<IForeslagetKartutsnitt>;
    calculate(id: number): Observable<IForeslagetKartutsnitt>;
    getCreateCommandFor(id: number, kartutsnitt: IKartutsnitt): ICommand;
    getUpdateCommandFor(id: number, kartutsnitt: IKartutsnitt): ICommand;
    getDeleteCommandFor(id: number, kartutsnitt: IKartutsnitt): ICommand;
}
export class KartaSymbolDisplayItem {
    defaultSymbol: any;
    editSymbol: any;
    mouseOverSymbol: any;
    selectedSymbol: any;
    constructor(defaultSymbol: any, editSymbol?: any, mouseOverSymbol?: any, selectedSymbol?: any) {
        this.defaultSymbol = defaultSymbol;
        this.editSymbol = editSymbol;
        this.mouseOverSymbol = mouseOverSymbol;
        this.selectedSymbol = selectedSymbol;
    }
}
